/**
 * Created by christiancueni on 23/05/18.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import {Injectable} from '@angular/core';
import {IS_APP, IS_PRODUCTION} from "../app.constants";

interface TrackingData {
  view: string;
  path: string;
  section: string;
  subsection: string;
}

@Injectable()
export class AnalyticsService {

  private deviceReady = false;

  constructor() {
  }

  setupAnalytics() {
    if (IS_APP) {
      document.addEventListener('deviceready', () => {
        this.deviceReady = true;
      }, false);
    }
  }

  send(language = 'de', ...args: string[]) {
    if (IS_PRODUCTION && window['_paq'] && args.length > 1 && args[0] === 'pageview') {
      window['_paq'].push(['trackPageView', args[1]]);
    }
  }

  getPageName(url: string): TrackingData {

    const URL_PREFIX = '/klassenbuch'

    const normalUrlReg = /\/klassenbuch\/(\w+)$/;
    const normalUrlMatches = url.match(normalUrlReg);

    const eventUrlReg = /\/klassenbuch\/events\/\d+$/;
    const eventUrlMatches = url.match(eventUrlReg);

    const eventEditUrlReg = /\/klassenbuch\/events\/\d+\/edit$/;
    const eventDetailUrlMatches = url.match(eventEditUrlReg);

    const eventAddUrlReg = /\/klassenbuch\/events\/add/;
    const eventAddUrlMatches = url.match(eventAddUrlReg);

    const productsUrlReg = /\/app-products/;
    const productsUrlMatches = url.match(productsUrlReg);

    const premiumUrlReg = /\/premium/;
    const premiumUrlMatches = url.match(premiumUrlReg);

    if (url.indexOf(`${URL_PREFIX}?`) === 0 || url === URL_PREFIX) {
      return {
        view: 'klassenbuch',
        section: 'klassenbuch',
        subsection: '',
        path: 'klassenbuch'
      }
    } else if (normalUrlMatches !== null) {
      return {
        view: normalUrlMatches[1],
        section: normalUrlMatches[1],
        subsection: '',
        path: normalUrlMatches[1]
      }
    } else if (eventUrlMatches !== null) {
      return {
        view: 'event/detail/view',
        section: 'event',
        subsection: 'event/detail',
        path: 'event/detail/view'
      }
    } else if (eventDetailUrlMatches !== null) {
      return {
        view: 'event/edit/view',
        section: 'event',
        subsection: 'event/edit',
        path: 'event/edit/view'
      }
    } else if (eventAddUrlMatches !== null) {
      return {
        view: 'event/add/view',
        section: 'event',
        subsection: 'event/add',
        path: 'event/add/view'
      }
    } else if (productsUrlMatches !== null) {
      return {
        view: 'products',
        section: 'products',
        subsection: '',
        path: 'app-products'
      }
    } else if (premiumUrlMatches !== null) {
      return {
        view: 'premium',
        section: 'premium',
        subsection: '',
        path: 'premium'
      }
    }
    return {
      view: 'klassenbuch',
      section: 'klassenbuch',
      subsection: '',
      path: 'klassenbuch'
    }
  }

}
